// extracted by mini-css-extract-plugin
module.exports = {"phone":"PictoPhone_phone__iehZm","connected":"PictoPhone_connected__qIDro"};